import SizeBox from 'components/common/SizeBox';
import { DESKTOP_MIN_WIDTH } from 'constants';
import useReferral from 'features/referral/hooks/useReferral';
import React from 'react';
import styled from 'styled-components';
import CustomTrackingAccordion from './CustomTrackingAccordion';

export const refereeTrackingClassName = 'referee-tracking';

const RefereeTracking = ({ paddingTop }) => {
  const {
    isReferrerTracking,
    isReferrerReward,
    pendingTrackingList,
    completedTrackingList,
  } = useReferral();

  if (isReferrerTracking || isReferrerReward)
    return (
      <>
        <RefereeTrackingStyled
          className={refereeTrackingClassName}
          $paddingTop={paddingTop}
        >
          <CustomTrackingAccordion
            data={completedTrackingList}
            isSuccess={true}
          />
          <CustomTrackingAccordion
            data={pendingTrackingList}
            isSuccess={false}
          />
        </RefereeTrackingStyled>
        <SizeBox height={16} />
      </>
    );
  return null;
};

const RefereeTrackingStyled = styled.div`
  display: grid;
  gap: 12px;
  height: fit-content;
  margin-top: ${(props) => props.$paddingTop}px;
  padding-inline: 16px;
  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin-top: 46px;
    padding-inline: 0px;
    gap: 20px;
  }
`;

export default RefereeTracking;
